import { render } from "./RecipeCategories.vue?vue&type=template&id=8fc7223e"
import script from "./RecipeCategories.vue?vue&type=script&lang=js"
export * from "./RecipeCategories.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__